export const buyerData = [
  {
    heading: 'Increase your purchasing power',
    description:
      'Get an approved purchasing line of credit &mdash; secure a lower cost of goods, drive sales growth, and avoid stock outs.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/credit-summary@1x.png',
        width: 520,
        height: 470,
      },
      '2x': {
        path: '/static/img/digital-onboarding/credit-summary@2x.png',
        width: 1040,
      },
    },
    imageAlt: 'Credit Summary graphic',
  },
  {
    heading: 'Process payments easily & digitally',
    description: 'Reliable and secure via our trusted third party financial institutions and partners.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/paid-invoice@1x.png',
        width: 290,
        height: 290,
      },
      '2x': {
        path: '/static/img/digital-onboarding/paid-invoice@2x.png',
        width: 580,
      },
    },
    imageAlt: 'Paid Invoice graphic',
  },
  {
    heading: 'Centralize your Accounts Payable',
    description:
      "Reduce the volume of payees and payments to manage &mdash; increasing your team's speed and efficiency.",
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/payment-calendar@1x.png',
        width: 400,
        height: 320,
      },
      '2x': {
        path: '/static/img/digital-onboarding/payment-calendar@2x.png',
        width: 800,
      },
    },
    imageAlt: 'Payment Calendar graphic',
  },
  {
    heading: 'Optimize cash flow & gain greater financial flexibility',
    description: 'Invest back in the growth of your business.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/request-customer-payment@1x.png',
        width: 440,
        height: 301,
      },
      '2x': {
        path: '/static/img/digital-onboarding/request-customer-payment@2x.png',
        width: 880,
      },
    },
    imageAlt: 'Request Customer Payment graphic',
  },
  {
    heading: 'Take advantage of net payment terms <br>(e.g. Net 30) & payment extension offers',
    description: 'Allowing you to sell your inventory before paying for it.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/payment-request-sent@1x.png',
        width: 260,
        height: 260,
      },
      '2x': {
        path: '/static/img/digital-onboarding/payment-request-sent@2x.png',
        width: 520,
      },
    },
    imageAlt: 'Payment Request Sent graphic',
  },
];

export const sellerData = [
  {
    heading: 'Speed up your time-to-cash',
    description: 'Allocate working capital into other facets of the business.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/credit-summary@1x.png',
        width: 520,
        height: 470,
      },
      '2x': {
        path: '/static/img/digital-onboarding/credit-summary@2x.png',
        width: 1040,
      },
    },
    imageAlt: 'Credit Summary graphic',
  },
  {
    heading: 'Automate & centralize your <br>Accounts Receivable',
    description: 'Allowing you to increase speed and efficiency.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/paid-invoice@1x.png',
        width: 290,
        height: 290,
      },
      '2x': {
        path: '/static/img/digital-onboarding/paid-invoice@2x.png',
        width: 580,
      },
    },
    imageAlt: 'Paid Invoice graphic',
  },
  {
    heading: 'Generate more sales',
    description: 'Giving your customers more purchasing power.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/payment-calendar@1x.png',
        width: 400,
        height: 320,
      },
      '2x': {
        path: '/static/img/digital-onboarding/payment-calendar@2x.png',
        width: 800,
      },
    },
    imageAlt: 'Payment Calendar graphic',
  },
  {
    heading: 'Process payments that are both reliable and secure',
    description: 'Backed by trusted financial institutions.',
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/request-customer-payment@1x.png',
        width: 440,
        height: 301,
      },
      '2x': {
        path: '/static/img/digital-onboarding/request-customer-payment@2x.png',
        width: 880,
      },
    },
    imageAlt: 'Request Customer Payment graphic',
  },
  {
    heading: 'Get paid upon delivery confirmation',
    description: "Let LeafLink assume the risk of non-payment &mdash; you're not liable for unpaid invoices.",
    image: {
      '1x': {
        path: '/static/img/digital-onboarding/payment-request-sent@1x.png',
        width: 260,
        height: 260,
      },
      '2x': {
        path: '/static/img/digital-onboarding/payment-request-sent@2x.png',
        width: 520,
      },
    },
    imageAlt: 'Payment Request Sent graphic',
  },
];
